<template>
  <div>
    <p class="header">Take a look at this hotel room in Paris.</p>
    <div class="image-holder">
      <img class="image" src="@/assets/main.png" />
      <div class="small-image-holder">
        <img class="image" src="@/assets/side1.png" />
        <img class="image" src="@/assets/side2.png" />
      </div>
    </div>
    <p class="header unrline">Ready?</p>
    <bg-button class="button" @click="$router.push({ name: 'stepfour' })" text="Yes, let's go!"></bg-button>
  </div>
</template>

<style scoped>
.unrline {
  text-decoration: underline;
}
.header {
  margin-bottom: 40px;
  font-size: 18px;
}
.paragraph {
  margin-bottom: 10px;
}
.image-holder {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  min-height: 341px;
}
.image {
  width: auto;
  margin: 5px;
  max-width: initial;
}
.small-image-holder {
  display: flex;
  flex-direction: column;
}
</style>

<script>
import BgButton from "../components/bg-button";
export default {
  name: "App",
  components: {
    BgButton
  }
};
</script>
